import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getScreenViewVertical } from '../functions';
import { RootState } from '../store';
import { getExpandedItems } from '../table/functions';
import { ItemType, MappingItemIdIndexType } from '../types';
import GantItem from './gantItem';

const GantItemList = () => {
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const currentScrollY = useSelector<RootState, number>((state) => state.gantScroll.currentScrollY);
    const availableHeight = useSelector<RootState, number>((state) => state.gant.availableHeight);

    const { start, end } = getScreenViewVertical(currentScrollY, availableHeight);

    const newItems = useMemo(() => {
        return getExpandedItems(itemsList, mappingItemIdIndex).slice(start, end);
    }, [itemsList, start, end]);

    const content = useMemo(() => {
        return newItems.map((item) => {
            return (
                <GantItem
                    key={item.id}
                    item={item}
                    // itemAsJson={JSON.stringify(item)}
                />
            );
        });
    }, [newItems]);

    return <>{content}</>;
};

export default React.memo(GantItemList);
